import { Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import NextLink from "../others/NextLink";

const Breadscrumb = ({
  paths,
}: {
  paths: { title: string; url: string }[];
}) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        background: theme.palette.background.layout,
        width: "100%",
        pb: 2,
        alignItems: "center",
      }}
    >
      <Divider sx={{ width: "40%" }} />
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "center",
          flexWrap: "wrap",
          pt: 1,
        }}
      >
        {paths.map((path, index) => (
          <Stack key={index} flexDirection="row">
            <Typography
              key={index}
              sx={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              {">"}
            </Typography>
            <NextLink href={path.url}>
              <Typography
                key={index}
                sx={{
                  px: 2,
                  "&:hover": {
                    fontWeight: theme.typography.fontWeightMedium,
                    color: theme.palette.primary.dark,
                  },
                }}
              >
                {path.title}
              </Typography>
            </NextLink>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default Breadscrumb;
